import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { parse, ParseResult } from 'papaparse';
import { Readable } from 'stream';
import { CSVRatesRow } from '~/types';

const client = new S3Client({
    apiVersion: '2006-03-01',
});

const getObject = (bucket: string, filename: string, versionId?: string) => {
    const command = new GetObjectCommand({ Bucket: bucket, Key: filename, VersionId: versionId });
    return client.send(command);
};

export const getJSONDocumentFromCSV = async (bucket: string, filename: string, versionId?: string) => {
    const { Body } = await getObject(bucket, filename, versionId);
    if (!Body) {
        throw Error(`Failed to retrieve '${filename}' from ${bucket}`);
    }
    const stream = Body as Readable;
    const chunks: Uint8Array[] = [];
    for await (const chunk of stream) {
        chunks.push(chunk);
    }
    const csvData = Buffer.concat(chunks).toString('utf-8');

    const { data, errors }: ParseResult<CSVRatesRow> = parse(csvData, {
        header: true,
        skipEmptyLines: true,
        dynamicTyping: true,
        delimiter: ',',
    });

    if (errors?.length) {
        const errorMessage = 'Unable to parse CSV';
        console.error(errorMessage, errors[0]);
        throw new Error(errorMessage);
    }

    return data[0];
};
